<template>
    <main id="home-wrapper">
        <div id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'Kontak Paguyuban', url: app_url+'/kontak-paguyuban', status: true }
                ]"
            ></breadcrumb>


            <section id="headline-paguyuban" class="section withPad blackBg">
                <div class="inner_wrap">
                    <div class="head-title-paguyuban">
                        <h3>Kontak Paguyuban</h3>

                        <div class="flex_select">
                                <div class="custom_vselect custom_vselect-large">
                                    <v-select
                                        :options="provinces"
                                        label="name"
                                        :placeholder="provincePlaceholder"
                                        @input="changeProvince($event,'province')"
                                        v-model="province"
                                    >
                                    </v-select>
                                </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="paguyuban-person" class="section withPad">
                <div class="container" v-if="paguyuban && paguyuban.length == 0">
                    <div  class="messagebox">
                        <h4>Belum ada Kontak Paguyuban</h4>
                    </div>
                </div>
                <div class="container" v-else>
                    <div class="list-paguyuban mobile_list" v-if="mobile">
                        <div class="row-grid">
                            <div class="col-grid-50" v-for="(data, index) in paguyuban" :key="index">
                                <div class="box_person">
                                    <div class="row-grid">
                                        <div class="col-grid-50">
                                            <div class="thumb_items_person">
                                                <img :src="data.image" />
                                            </div>
                                        </div>
                                        <div class="col-grid-50">
                                            <div class="nama_row">
                                                <a :href="data.linkbrother"><h3 class="red">{{ data.nama_panggilan }}</h3>
                                                <h3>{{ data.nama_lengkap }}</h3></a>
                                            </div>
                                            <div class="abs_row">
                                                <div class="row_socmed">
                                                    <a target="_blank" :href="data.sosmed_tw" class="icon_scomed"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                                    <a target="_blank" :href="data.sosmed_in" class="icon_scomed"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                                    <a target="_blank" :href="data.youtube" class="icon_scomed"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
                                                </div>
                                                <a target="_blank" :href="data.whatsapp" class="wa_hubungi">
                                                    <i class="fa fa-whatsapp" aria-hidden="true"></i>
                                                    <span>Hubungi</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="acc_detail">
                                        <div class="row_tabs_detail">
                                            <a :ref="'items'+index" @click="toggleAccordion('items'+index, index)" class="tabs_detail"><span>Detail</span> <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                        </div>
                                        <div class="content_detail" :ref="'content_detail-'+index">
                                            <div class="info_person">
                                                <div class="detail_person">
                                                    <label>Tempat / Tanggal Lahir</label>
                                                    <span>{{ data.tempat_lahir }} / {{ data.tanggal_lahir }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Main Dealer </label>
                                                    <span>{{ data.maindealer }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Area</label>
                                                    <span>{{ data.area }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Alamat Website </label>
                                                    <span>{{ data.domain }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Komunitas </label>
                                                    <span>{{ data.komunitas }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <a :href="data.linkbrother" class="seeMore">Lihat Profile</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="pagination">
                            <Pagination></Pagination>
                        </div>
                    </div>

                    <div class="list-paguyuban" v-else>
                        <div v-if="loader" class="loading loading-double"></div>
                        <div v-else class="row-grid">
                            <div class="col-grid-50" v-for="(data, index) in paguyuban" :key="index">
                                <div class="box_person">
                                    <div class="row-grid">
                                        <div class="col-grid-50">
                                            <div class="thumb_items_person">
                                                <img :src="data.image" />
                                            </div>
                                            <div class="nama_row">
                                                <a :href="data.linkbrother"><h3 class="red">{{ data.nama_panggilan }}</h3>
                                                <h3>{{ data.nama_lengkap }}</h3></a>

                                            </div>
                                        </div>

                                        <div class="col-grid-50">
                                            <div class="info_person">
                                                <div class="detail_person">
                                                    <label>Tempat / Tanggal Lahir</label>
                                                    <span>{{ data.tempat_lahir }} / {{ data.tanggal_lahir }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Main Dealer </label>
                                                    <span>{{ data.maindealer }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Area</label>
                                                    <span>{{ data.area }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Alamat Website </label>
                                                    <span>{{ data.domain }}</span>
                                                </div>

                                                <div class="detail_person">
                                                    <label>Komunitas </label>
                                                    <span>{{ data.komunitas }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="abs_row">
                                        <div class="row_socmed">
                                            <a target="_blank" @click="gtmTrackerSocmed(data, data.sosmed_tw, 'Twitter', 1)" :href="data.sosmed_tw" class="icon_scomed"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                            <a target="_blank" @click="gtmTrackerSocmed(data, data.sosmed_in, 'Instagram', 2)" :href="data.sosmed_in" class="icon_scomed"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                            <a target="_blank" @click="gtmTrackerSocmed(data, data.youtube, 'Youtube', 3)" :href="data.youtube" class="icon_scomed"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
                                        </div>
                                        <a target="_blank" @click="gtmTrackerContact(data)" :href="data.whatsapp" class="wa_hubungi">
                                            <i class="fa fa-whatsapp" aria-hidden="true"></i>
                                            <span>Hubungi</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pagination">
                            <Pagination></Pagination>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import Pagination from "../../widget/Pagination";
import { isMobile } from "mobile-device-detect";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
import $ from 'jquery';

export default {
    components: {
        breadcrumb: BreadCrumb,
        "v-select": vSelect,
        Pagination
    },
    data() {
        return {
            currentUrl: '',
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            paguyuban: null,
            provinces:[],
            province:'',
            loader:true,
            provincePlaceholder:'Cari Paguyuban di Provinsimu',
        };
    },
    created() {
        this.currentUrl = window.location.href;
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getPaguyuban(api_url+'/paguyuban');
        this.getProvince();
    },
    mounted(){
        $(".tabs_detail").click(function (e) {
          console.log(e)
            e.preventDefault();
            var parentRow = $(this).closest(".acc_detail");
            $(parentRow).find('.content_detail').slideToggle("");
            $(this).toggleClass("actived");
        });

    },
    methods: {
        // GTM Tracker
        gtmTracker(event) {
            var data = {
                'event': 'communityContactSearch',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Community Contact Search',
                'eventDetail.label': this.currentUrl,
                'province': event.name
            }
            dataLayer.push(data);
        },
        gtmTrackerContact(event) {
            var data = {
                'event': 'communityContactClick',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Community Contact Click',
                'eventDetail.label': 'Whatsapp',
                'dealerName': event.maindealer,
                'province': event.province,
                'communityName': event.komunitas,
                'destinationPageUrl': event.whatsapp
            }
            console.log(data)
            dataLayer.push(data)
        },
        gtmTrackerSocmed(daeler ,url, app, position) {
            let data = {
                'event': 'communityContactClick',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Community Contact Follow',
                'eventDetail.label': app,
                'position': position,
                'dealerName': daeler.maindealer,
                'province':daeler.area,
                'communityName':daeler.komunitas,
                'destinationPageUrl': url
            }
            dataLayer.push(data)
        },
        // End GTM Tracker
        getProvince() {
                this.loadderforms = true;
                axios.get(api_url+'/static/province')
                    .then(response => {
                        this.provinces = response.data.data.provincy;
                        this.loadderforms = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        changeProvince(event,label){
            console.log(event);
            this.gtmTracker(event);
            this.getPaguyuban(api_url+'/paguyuban/'+event._id);
        },
        toggleAccordion(element, index){
          let el = this.$refs[element];
          let contentDetail = this.$refs['content_detail-'+index];
          var parentRow = $(el[0]).closest(".acc_detail");
          $(parentRow).find(contentDetail[0]).slideToggle("");
          $(el[0]).toggleClass("actived");
          // let page = el[0].children[0];
          // if(page.classList.value.includes("active")){
          //   page.classList.remove('active');
          // }else{
          //   page.classList.add('active');
          // }
          // let content = el[0].children[1];
          // if(content.classList.value.includes("active")){
          //   content.classList.remove('active');
          // }else{
          //   content.classList.add('active');
          // }
        },
        getPaguyuban(endpoint) {
            this.loader = true;
            axios.get(endpoint)
                .then(res => {
                if (res.status == 200) {
                    if (res?.data?.status) {
                        this.loader = false;
                        this.paguyuban = res.data.data.paguyuban
                    }
                }
                    console.log(res);
                }).catch(error => {
                    this.loader = false;
                    this.paguyuban= [];
                    console.log(error);
                });
        },
    }
};
</script>

<style scoped lang="scss">
.img-promo-section-event {
    border-radius: 0px;
    float:right;
    overflow: hidden;
    img {
        max-width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share a {
    margin-top: 0;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.group_icon_detail .wrap-label{
    margin-bottom:-15px;

}
#headline-events .col-grid-50.flex_align_center{
  display:flex;
  flex:1;
  align-items:center;
}
#row-middle-events{
    padding-top:20px;
    padding-bottom:20px;
    border-top:1px solid rgba(219,219,219,0.1);
    border-bottom:1px solid rgba(219,219,219,0.1);
}
.flex-beetwen{
    display:flex;
    align-items:center;
    justify-content: space-between;
}
.isi-event h3{
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
}
.isi-event p{
    font-weight: 300;
    font-size: 15px;
    color: #B4B4B4;
}
.list-paguyuban .row-grid{
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.list-paguyuban .row-grid .col-grid-50{
    margin-bottom:30px;
}
@media all and (max-width:767px){
  .list-paguyuban .row-grid .col-grid-50{
    margin-bottom:0;
  }
}
</style>
